export enum BankingSalesName  {
  DISCOUNT_TYPE_NAME = 'Cash Up Stand Alone',
  SERVICE_CHARGE_TYPE_NAME = 'Cash Up Stand Alone',
  ORDER_PAYMENT_MESSAGE = 'Cash Up Stand Alone',
  DEFAULT_PRODUCT = 'Cash Up Stand Alone'
}